/**
 * the Cantor pairing function, which creates a unique natural number for a pair of natural numbers (order dependent)
 */
export function cantorPairing(a: number, b: number) {
  return ((a + b) * (a + b + 1)) / 2 + b
}
